import { undoValidUntilSelector } from '../modules/todo/selectors';


const offlineUndoEnhancer = (createStore) => (
  reducer,
  initialState,
  enhancer,
) => {
  const reducerWithUndo = (state, action) => {
    const newState = reducer(state, action);

    if (action.type === 'LOGOUT_REQUEST') {
      return {
        ...newState,
        offline: {
          ...newState.offline,
          undoOutbox: null,
          outbox: [],
        },
      };
    }
    if (action.type === 'UNDO_LAST_ACTION' && state.offline.undoOutbox) {
      const diff = undoValidUntilSelector(state) - new Date();
      if (diff > 0) {
        return {
          ...newState,
          offline: {
            ...newState.offline,
            outbox: newState.offline.undoOutbox,
            undoOutbox: null,
          },
        };
      }
    }
    if (action.type === 'SET_UNDO_CHECKPOINT') {
      return {
        ...newState,
        offline: {
          ...newState.offline,
          undoOutbox: newState.offline.outbox,
        },
      };
    }
    return newState;
  };

  return createStore(reducerWithUndo, initialState, enhancer);
};

export default offlineUndoEnhancer;
